<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('frontCover.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('frontCover.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <div class="overflow-auto">
        <ts-table :records="resources" :columnLengths="8">
          <template v-slot:thead>
            <thead>
              <tr>
                <th style="width: 80%">{{ $t('frontCover.image') }}</th>
                <th class="text-center" style="width:10%">
                  {{ $t('frontCover.active') }}
                </th>
                <!-- <th class="text-center">
                  {{ $t('frontCover.desktop') }}
                </th> -->
                <!-- <th class="text-center">
                  {{ $t('frontCover.device') }}
                </th> -->
                <!-- <th width="10%">
                  {{ $t('frontCover.second') }}
                </th> -->
                <!-- <th>{{ $t('frontCover.startDate') }}</th>
                <th>{{ $t('frontCover.endDate') }}</th> -->
                <th style="width: 1px" class="text-right">
                  <a
                    href="#"
                    class="btn btn-xs btn-info"
                    @click.prevent="addNewRow"
                  >
                    <i class="fa fa-plus"></i>
                  </a>
                </th>
              </tr>
              <TableProgressBar v-show="loading" :columnLength="8" />
            </thead>
          </template>
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              <ts-image-input
                :file="record.image_path ? record.image_path : file"
                @input="(file) => (record.image = file)"
                @submit="save(record)"
                :width="105"
                :height="59"
                crop
                class="ts-float-left"
              ></ts-image-input>
            </td>
            <td class="text-center">
              <a-switch
                size="small"
                :checked="record.is_active"
                @change="isActiveCloseOpen(record)"
              />
            </td>
            <!-- <td class="text-center">
              <a-switch
                size="small"
                :checked="record.is_default"
                @change="isDefaultCloseOpen(record)"
                v-if="record.start_date === null || record.end_date === null"
              />
            </td> -->
            <!-- <td class="text-center">
              <a-switch
                size="small"
                :checked="record.is_device_display"
                @change="isDeviceCloseOpen(record)"
                v-if="record.start_date === null || record.end_date === null"
              />
            </td> -->
            <!-- <td class="ts-whitespace-no-wrap">
              <input
                type="number"
                class="form-control"
                v-model.number="record.interval_second"
              />
            </td> -->
            <!-- <td class="ts-whitespace-no-wrap">
              <ts-date-picker-input
                v-model="record.start_date"
              ></ts-date-picker-input>
            </td>
            <td class="ts-whitespace-no-wrap">
              <ts-date-picker-input
                v-model="record.end_date"
              ></ts-date-picker-input>
            </td> -->
            <td class="ts-whitespace-no-wrap text-right">
              <ts-button
                :color=" record.id > 0 ? 'primary': 'danger'"
                class="btn-xs mr-2"
                @click="save(record)"
              >
                <i class="fas fa-circle-notch spin" v-if="record._saving"></i>
                <i class="fa fa-save" v-else></i>
              </ts-button>
              <ts-button
                color="danger"
                class="btn-xs"
                @click.prevent="removeRow(record)"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash" v-else></i>
              </ts-button>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'frontCover',
  components: {
    TableProgressBar,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      file: require('../../../assets/cover-default-image.png'),
      newRow: {
        id: 0,
        interval: 3,
        start_date: null,
        end_date: null,
        image_order: null,
        is_default: true,
        is_device_display: true,
        is_active: true,
        image_path: null,
        _saving: false,
        _deleting: false,
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/frontCover', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.frontCover.search
      },
      set(newValue) {
        this.$store.commit('administrator/frontCover/SET_SEARCH', newValue)
        this.$store.commit('administrator/frontCover/RESET_CURRENT_PAGE')
      },
    },
  },
  methods: {
    isActiveCloseOpen(record) {
      record.is_active = record.is_active ? false : true
    },
    isDefaultCloseOpen(record) {
      record.is_default = record.is_default ? false : true
    },
    isDeviceCloseOpen(record) {
      record.is_device_display = record.is_device_display ? false : true
    },
    addNewRow() {
      this.resources.push(_.clone(this.newRow))
    },
    removeRow(record) {
      record._deleting = true
      if (record.id > 0) {
        this.$store
          .dispatch('administrator/frontCover/destroy', record.id)
          .then((response) => {
            record._deleting = false
            this.resources.splice(this.resources.indexOf(record), 1)
            this.$toasted.success(response.message)
          })
          .catch((error) => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      } else {
        this.resources.splice(this.resources.indexOf(record), 1)
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/frontCover/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    appendFormData(item) {
      let formData = new FormData()

      if (item.id > 0) {
        formData.append('_method', 'PUT')
      } else {
        formData.append('image_order', this.resources.indexOf(item) + 1)
      }
      formData.append('start_date', item.start_date)
      formData.append('end_date', item.end_date)
      formData.append(
        'is_default',
        item.start_date !== null || item.end_date !== null
          ? false
          : item.is_default
      )
      formData.append(
        'is_device_display',
        item.start_date !== null || item.end_date !== null
          ? false
          : item.is_device_display
      )
      formData.append('is_active', item.is_active)
      formData.append(
        'interval',
        item.interval_second ? item.interval_second * 1000 : 0
      )

      if (item.image instanceof File || item.image instanceof Blob) {
        formData.append('image', item.image)
      }

      return formData
    },

    async save(item) {
      item._saving = true
      this.$store
        .dispatch('administrator/frontCover/store', {
          id: item.id,
          data: this.appendFormData(item),
        })
        .then((response) => {
          item._saving = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          item._saving = false
          this.errors = new Errors(error.errors)
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administrator/frontCover/RESET_STATE')
    }
    next()
  },
}
</script>

<style lang="css" scoped>
table td {
  vertical-align: middle;
}
</style>
